import { useContext, useEffect, useState, useMemo } from 'react';

import "./styles/App.scss"

import Login from './components/pages/Login';
import Projects from './components/pages/Projects';
import Project from './components/pages/Project';
import CreateActivity from './components/pages/CreateActivity';
import CreateQuiz from './components/pages/CreateQuiz';
import CreateModule1 from './components/pages/CreateModule1';
import CreateModule2 from './components/pages/CreateModule2';
import Profile from './components/pages/Profile';
import Edit from './components/pages/Edit';
import Analytics from './components/pages/Analytics';
import EditQuiz from './components/pages/EditQuiz';
import Links from './components/pages/Links';
import Search from './components/pages/Search';
import Notifications from './components/pages/Notifications';
import ChangePassword from './components/pages/ChangePassword';

import Examples from './components/pages/Examples';

import { BrowserRouter as Router, Route, Routes} from 'react-router-dom'

import { AuthProvider, AuthContext } from './context/AuthContext';
import { ProjectsContext } from "./context/ProjectsContext";
import { NotificationsContext } from "./context/NotificationsContext";

import PrivateRoute from "./components/PrivateRoute";

import { getAuth, onAuthStateChanged } from "firebase/auth";

import db from "./firebase";
import { UpdateAnalytics } from './utils/UpdateAnalytics';
import { doc, getDocs, collection, query, where, orderBy, getDoc, documentId, onSnapshot, setDoc, arrayUnion, Timestamp, FieldPath } from "firebase/firestore";

function App() {

    const [ projects, setProjects ] = useState(false);
    const projectsValue = useMemo(() => ({ projects, setProjects }), [projects, setProjects]);

    const [ notifications, setNotifications ] = useState(false);
    const notificationsValue = useMemo(() => ({ notifications, setNotifications }), [notifications, setNotifications]);

    useEffect(() => {
        document.title = 'Lagoon';

    }, []);

    //========================================
    //========================================
    //========================================
    // get user

    const [currentUser, setCurrentUser] = useState(null);
    const auth = getAuth();
    useEffect(() => {
        onAuthStateChanged(auth, (user) => {
            if (user) {
                const uid = user.uid;
                setCurrentUser(uid);
            } else {
                setCurrentUser(0);
            };
        });
    }, []);

    //========================================
    //========================================
    //========================================
    // get projects

    useEffect(() => {

		if (currentUser && !projects){

			const ref = collection(db, "projects");
			let q = query(
				ref,
				where('user', '==', currentUser),
				orderBy('name')
			);
			var projects = [];
			const unsubscribe = onSnapshot(q, (snapshot) => {

				let projectsList = snapshot.docs.map((doc) => ({ ...doc.data(), id: doc.id }));

				console.log('got user projects');

				setProjects(projectsList);
				getAnalytics(projectsList);

			});
			return () => unsubscribe()
		}

	}, [currentUser]);


    //================================================================
    // get from firebase (split into 30 due to firebase restrictions)

	const getAnalytics = async(projects) => {

		//========================
		// get project analytics

        let ids = [];
        for (let key in projects){
            let project = projects[key];
            ids.push(project['id'])
        }
        while (ids.length) {
            const batch = ids.splice(0, 30);
            const analyticsQuery = query(
                collection(db, "analytics"),
                where(documentId(), "in", batch)
            );
            const analyticsSnapshot = await getDocs(analyticsQuery);
            analyticsSnapshot.forEach((doc, id) => {
                let data = doc.data();
                data.id = doc.id;
                for (let key in projects){
                    let project = projects[key];
                    if (project.id == data.id)
                        project['analytics'] = data;
                }


            });
        }

        /*
		for (let key in projects){
			let project = projects[key];
			const analyticsRef = doc(db, "analytics", project['id']);
			const analyticsDoc = await getDoc(analyticsRef);
			const analytics = { ...analyticsDoc.data(), id: analyticsDoc.id };
			project['analytics'] = analytics;
		}*/

		console.log('got projects analytics');

		setProjects([...projects]);

		//=====================================================================================
		// update project analytics from "actions" collection firebase (if not updated before)

		projects = await UpdateAnalytics(projects);

		console.log('calculated analytics for new projects');

		setProjects([...projects]);

        //=========================================
		// get project users (search by user && leaderboard in project)

		for (let key in projects){
			let project = projects[key];
			if (project['analytics'] && project['analytics']['users'] && project['analytics']['users'].length > 0){

                let users = [];
                let ids =[...project['analytics']['users']];
                while (ids.length) {
                    const batch = ids.splice(0, 30);
                    const usersQuery = query(
                        collection(db, "users"),
                        where(documentId(), "in", batch)
                    );
                    const usersSnapshot = await getDocs(usersQuery);
                    usersSnapshot.forEach((doc) => {
                        let data = doc.data();
                        data.id = doc.id;
                        users.push(data);
                    });
                }

                projects[key]['usersList'] = users;

			}
		}

		console.log('got project users');

		setProjects([...projects]);
	}

	//========================================
	//========================================
	//========================================
	// get user notifications from firebase

	useEffect(() => {

		if (currentUser){

			const notificationsRef = doc(db, "notifications", currentUser);

			const unsubscribe = onSnapshot(notificationsRef, (doc) => {
				let data = doc.data();
				if (data && data.notifications){
					let notifications = data.notifications.reverse();

					setNotifications(notifications);
					//console.log('get notifications');
				} else {
                    setNotifications('not found');
                }
			});
			return () => unsubscribe()
		}

	}, [currentUser]);

	//====================================================================
	// add text to notifications about the number of users in the project

	useEffect(() => {

        if (projects && notifications){
            for(let key in notifications){
                let notification = notifications[key];
                if (notification['project']){
                    for (let key in projects){
                        let project = projects[key];
                        if (project['id'] == notification['project']){
                            notification['text'] = 'Congratulations! There are already '+notification.count+' users in the project "'+project.name+'"';
                        }
                    }
                }
            }

            setNotifications(notifications);
        }

	}, [projects, notifications]);

    //===========================================================
	// add notifications about number of users (add to firebase)

	const updateNotifications = async () => {

		//console.log('updateNotifications');

        if (projects && notifications && currentUser){
            for(let key in projects){
                let project = projects[key];
                if (project.analytics){
                    if (project.analytics.users) {
                        let count = project.analytics.users.length;
                        createNotification(5, project.analytics, project.id);
                        createNotification(10, project.analytics, project.id);
                        createNotification(50, project.analytics, project.id);
                    }
                }
            }
        }
	}
	useEffect(() => {

        updateNotifications();

    }, [projects, notifications, currentUser]);

    //======================================================

	const createNotification = async (count, analytics, projectId) => {

        const now = Timestamp.now();

		//console.log('count');
		//console.log(count);
		//console.log(analytics);

		if (analytics.users.length >= count && (!analytics.notifications || !analytics.notifications[count])) {

			// add to analytics collection (eliminate duplicate notifications)
			if (!analytics.notifications)
				analytics.notifications = {};
			analytics.notifications[count] = true;

            const analyticsRef = doc(db, "analytics", projectId);
			await setDoc(analyticsRef, {
				notifications: analytics.notifications,
			}, { merge: true });

			const notificationsRef = doc(db, "notifications", currentUser);
			await setDoc(notificationsRef, {
				notifications: arrayUnion(
					{
						timestamp: now,
						project: projectId,
						count: count,
					}
				),
			}, { merge: true });
		}
	}

    return (

        <AuthProvider>
            <ProjectsContext.Provider value={projectsValue}>
                <NotificationsContext.Provider value={notificationsValue}>
                    <Router>
                        <Routes>
                            <Route path="/auth" element={<Login />} />
                            <Route path="/" element={
                                <PrivateRoute>
                                    <Projects />
                                </PrivateRoute>
                            }/>
                            <Route path="/project/:id" element={
                                <PrivateRoute>
                                    <Project />
                                </PrivateRoute>
                            }/>
                            <Route path="/project" element={
                                <PrivateRoute>
                                    <Project />
                                </PrivateRoute>
                            } />
                            <Route path="/links" element={
                                <PrivateRoute>
                                    <Links />
                                </PrivateRoute>
                            } />
                            <Route path="/login" element={
                                <PrivateRoute>
                                    <Login />
                                </PrivateRoute>
                            } />
                            <Route path="/projects" element={
                                <PrivateRoute>
                                    <Projects />
                                </PrivateRoute>
                            } />
                            <Route path="/create" element={
                                <PrivateRoute>
                                    <Edit type="create_project"/>
                                </PrivateRoute>
                            } />
                            <Route path="/create_activity" element={
                                <PrivateRoute>
                                    <CreateActivity />
                                </PrivateRoute>
                            } />
                            <Route path="/create_quiz" element={
                                <PrivateRoute>
                                    <CreateQuiz />
                                </PrivateRoute>
                            } />
                            <Route path="/create_module1" element={
                                <PrivateRoute>
                                    <CreateModule1 />
                                </PrivateRoute>
                            } />
                            <Route path="/create_module2" element={
                                <PrivateRoute>
                                    <CreateModule2 />
                                </PrivateRoute>
                            } />
                            <Route path="/edit/:id" element={
                                <PrivateRoute>
                                    <Edit type="edit" />
                                </PrivateRoute>
                            } />
                            <Route path="/analytics/:id" element={
                                <PrivateRoute>
                                    <Analytics />
                                </PrivateRoute>
                            } />
                            <Route path="/edit_quiz" element={
                                <PrivateRoute>
                                    <EditQuiz />
                                </PrivateRoute>
                            } />
                            <Route path="/examples" element={
                                <PrivateRoute>
                                    <Examples />
                                </PrivateRoute>
                            } />
                            <Route path="/profile" element={
                                <PrivateRoute>
                                    <Profile />
                                </PrivateRoute>
                            } />
                            <Route path="/search" element={
                                <PrivateRoute>
                                    <Search />
                                </PrivateRoute>
                            } />
                            <Route path="/notifications" element={
                                <PrivateRoute>
                                    <Notifications />
                                </PrivateRoute>
                            } />
                            <Route path="/change-password" element={
                                <PrivateRoute>
                                    <ChangePassword />
                                </PrivateRoute>
                            } />
                        </Routes>
                    </Router>
                </NotificationsContext.Provider>
            </ProjectsContext.Provider>
        </AuthProvider>

    );
}

export default App;
